<template>
  <div class>
    <el-tabs
      v-model="activeName"
      type="card"
      @tab-click="handleClick"
      style="margin-top: 3em"
    >
      <el-tab-pane label="上下线记录" name="second">
        <STable
          ref="tableref2"
          :url="url2"
          :columns="columns2"
          :query="query2"
          :toolbar="toolbar2"
          :selection="true"
          labelWidth="120px"
        ></STable>
      </el-tab-pane>
      <el-tab-pane label="离线告警" name="first">
        <STable
          ref="tableref"
          :url="url"
          :columns="columns"
          :handles="handles"
          :query="query"
          :toolbar="toolbar"
          :selection="true"
          labelWidth="120px"
        ></STable>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import fieldFilter from "@/utils/fieldFilter.js";
import { HOST, EV_HOST } from "@/utils/host";
export default {
  name: "offlineAlarm",
  components: {},
  data() {
    return {
      url: "/battery/offline/page",
      url2: "/battery/offline/onOffPage",
      activeName: "second",
      columns: [
        {
          label: "SN号",
          prop: "SN"
        },
        {
          label: "设备名称",
          prop: "deviceName"
        },
        {
          label: "品牌型号",
          prop: "brandModel"
        },
        {
          label: "项目名称",
          prop: "projectName"
        },
        {
          label: "企业名称",
          prop: "companyName"
        },
        {
          label: "离线发生时间",
          prop: "happenTime"
        },
        {
          label: "离线恢复时间",
          prop: "recoverTime"
        },
        {
          label: "异常状态",
          prop: "status"
        },
        {
          label: "离线时长",
          prop: "offlineTime"
        },
        {
          label: "短信通知",
          prop: "sendSms"
        }
      ],
      // 操作栏
      handles: {
        width: 100,
        btns: [
          {
            label: "详情",
            style: "color:#00CC00",
            permission: "Offlinealarm.pagedetail",
            handle: resp => {
              this.$router.push({
                path: "./offlineAlarmDetail",
                query: { data: resp }
              });
            }
          }
        ]
      },
      query: [
        {
          label: "SN号",
          prop: "SN",
          placeholder: "请输入SN号"
        },
        {
          label: "设备名称",
          prop: "deviceName",
          placeholder: "请输入设备名称"
        },
        {
          label: "项目名称",
          prop: "projectName",
          placeholder: "请输入项目名称"
        },
        {
          label: "企业名称",
          prop: "companyName",
          placeholder: "请输入企业名称"
        },
        {
          label: "品牌型号",
          prop: "brandName",
          type: "cascadersingle",
          data: this.brandData,
          props: { value: "id", label: "name" },
          placeholder: "请选择品牌型号"
        },
        {
          label: "离线恢复时间",
          prop: "recoverTime",
          type: "date2",
          placeholder: "",
          option: {
            type: "datetimerange"
          }
        },
        {
          label: "离线时长",
          type: "scopeBox",
          prop: "scopeBox",
          placeholder: "",
          middleLabel: "小时 -",
          minProp: "offStartTime",
          maxProp: "offEndTime",
          unit: "小时",
          width: "20px"
        },
        {
          label: "异常状态",
          prop: "status",
          placeholder: "请选择异常状态",
          type: "select",
          data: [
            {
              label: "全部",
              value: ""
            },
            {
              label: "未恢复",
              value: "未恢复"
            },
            {
              label: "已恢复",
              value: "已恢复"
            }
          ]
        },
        {
          label: "短信通知",
          prop: "sendSms",
          placeholder: "请选择短信通知",
          type: "select",
          data: [
            {
              label: "否",
              value: 0
            },
            {
              label: "是",
              value: 1
            }
          ]
        }
      ],
      toolbar: [
        {
          label: "导出",
          permission: "Offlinealarm.export",
          type: "success",
          handle: resp => {
            const url = HOST + "/battery/offline/export";
            let queryData = this.$refs.tableref.getQueryData();
            console.log(queryData, "查询");
            queryData.token = window.localStorage.getItem("token");
            queryData.companyId = window.localStorage.getItem("curCompanyId");
            if (queryData.recoverTime) {
              queryData.recoverTime = queryData.recoverTime.join(",");
            }
            if (queryData.brandName) {
              queryData.brandName = queryData.brandName.join(",");
            }
            $.fileDownload(url, {
              httpMethod: "get",
              data: queryData,
              failCallback: (html, url) => {
                this.$notify({
                  title: "失败",
                  message: "导出失败",
                  type: "error"
                });
              }
            });
            // setTimeout(() => {
            if (queryData.recoverTime) {
              this.$refs.tableref.getQueryData().recoverTime = queryData.recoverTime.split(
                ","
              );
            }
            // }, 1000);
            if (queryData.brandName) {
              this.$refs.tableref.getQueryData().brandName = queryData.brandName.split(
                ","
              );
            }
          }
        },
        {
          label: "删除",
          permission: "",
          type: "danger",
          isSelectRowShow: false,
          url: "/battery/offline/delete",
          method: "delete",
          isConfirm: true,
          before: records => {
            let arr = [];
            records.map(ele => {
              arr.push(ele.id);
            });
            return {
              ids: arr
            };
          },
          handle: () => {
            this.$refs.tableref.queryTable();
          }
        }
      ],
      columns2: [
        {
          label: "SN号",
          prop: "SN"
        },
        {
          label: "设备名称",
          prop: "deviceName"
        },
        {
          label: "品牌型号",
          prop: "brandModel"
        },
        {
          label: "项目名称",
          prop: "projectName"
        },
        {
          label: "企业名称",
          prop: "companyName"
        },
        {
          label: "记录类型",
          prop: "type"
        },
        {
          label: "发生时间",
          prop: "happenTime"
        }
      ],

      query2: [
        {
          label: "SN号",
          prop: "SN",
          placeholder: "请输入SN号"
        },
        {
          label: "设备名称",
          prop: "deviceName",
          placeholder: "请输入设备名称"
        },
        {
          label: "项目名称",
          prop: "projectName",
          placeholder: "请输入项目名称"
        },
        {
          label: "企业名称",
          prop: "companyName",
          placeholder: "请输入企业名称"
        },
        {
          label: "品牌型号",
          prop: "brandName",
          type: "cascadersingle",
          data: this.brandData,
          props: { value: "id", label: "name" },
          placeholder: "请选择品牌型号"
        },
        {
          label: "记录类型",
          prop: "type",
          placeholder: "请选择记录类型",
          type: "select",
          data: [
            {
              label: "上线",
              value: "上线"
            },
            {
              label: "下线",
              value: "下线"
            }
          ]
        },
        {
          label: "发生时间",
          prop: "happenTime",
          type: "date2",
          placeholder: "",
          option: {
            type: "datetimerange"
          }
        }
      ],
      toolbar2: [
        {
          label: "导出",
          permission: "Onlineandofflinerecords.export",
          type: "success",
          handle: resp => {
            const url = HOST + "/battery/offline/onOffExport";
            let queryData = this.$refs.tableref2.getQueryData();
            queryData.token = window.localStorage.getItem("token");
            queryData.companyId = window.localStorage.getItem("curCompanyId");
            if (queryData.happenTime) {
              queryData.happenTime = queryData.happenTime.join(",");
            }
            if (queryData.brandName) {
              queryData.brandName = queryData.brandName.join(",");
            }
            $.fileDownload(url, {
              httpMethod: "get",
              data: queryData,
              failCallback: (html, url) => {
                this.$notify({
                  title: "失败",
                  message: "导出失败",
                  type: "error"
                });
              }
            });
            if (queryData.happenTime) {
              this.$refs.tableref2.getQueryData().happenTime = queryData.happenTime.split(
                ","
              );
            }
            if (queryData.brandName) {
              this.$refs.tableref2.getQueryData().brandName = queryData.brandName.split(
                ","
              );
            }
          }
        },
        {
          label: "删除",
          permission: "",
          type: "danger",
          isSelectRowShow: false,
          url: "/battery/offline/onOffDelete",
          method: "delete",
          isConfirm: true,
          before: records => {
            let arr = [];
            records.map(ele => {
              arr.push(ele.id);
            });
            return {
              ids: arr
            };
          },
          handle: () => {
            this.$refs.tableref2.queryTable();
          }
        }
      ]
    };
  },
  computed: {},
  methods: {
    getAlarmReason() {
      //告警原因
    },
    handleClick(tab, event) {},
    getBrandDataInfo() {
      this.$store.dispatch("form/handle", {
        url: "/battery/tree/brandModel",
        data: {},
        method: "get",
        callback: resp => {
          this.brandData = resp;
          this.getTreeData();
        }
      });
    },
    getTreeData() {
      for (var i = 0; i < this.brandData.length; i++) {
        if (this.brandData[i].children.length == 0) {
          // children若为空数组，则将children删除
          delete this.brandData[i].children;
        } else {
          for (var k = 0; k < this.brandData[i].children.length; k++) {
            if (this.brandData[i].children[k].children.length == 0) {
              // children若为空数组，则将children删除
              delete this.brandData[i].children[k].children;
            } else {
              for (
                var h = 0;
                h < this.brandData[i].children[k].children.length;
                h++
              ) {
                if (
                  this.brandData[i].children[k].children[h].children.length == 0
                ) {
                  // children若为空数组，则将children删除
                  delete this.brandData[i].children[k].children[h].children;
                }
              }
            }
          }
        }
      }
      this.$refs.tableref.query[4].data = this.brandData;
      this.$refs.tableref2.query[4].data = this.brandData;
    }
    // cascaderChange(param) {
    //   this.brandData.forEach(element=>{
    //     if(element.id==param.param[0]) {
    //       this.$refs.tableref2.queryForm.brandName = element.name;
    //       this.$refs.tableref.queryForm.brandName = element.name;
    //     }
    //     element.children.forEach(subElement=>{
    //       if(subElement.id==param.param[1]) {
    //         this.$refs.tableref2.queryForm.modelName = subElement.name;
    //         this.$refs.tableref.queryForm.modelName = subElement.name;
    //       }
    //     });
    //   });
    // },
    // date2Change(param) {
    //   this.$refs.tableref.queryForm.recoverStartTime = param.param[0];
    //   this.$refs.tableref.queryForm.recoverEndTime = param.param[1];
    //   // this.$refs.tableref.queryForm.recoverTime = param.param.join(',')
    //   // console.log(this.$refs.tableref.queryForm.recoverTime,'2222')
    // },
    // date2Change2(param) {
    //   this.$refs.tableref2.queryForm.happenStartTime = param.param[0];
    //   this.$refs.tableref2.queryForm.happenEndTime = param.param[1];
    // }
  },
  created() {
    this.getBrandDataInfo();
  },
  mounted() {},
  beforeCreate() {
    this.brandData = [];
  }, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped></style>



// WEBPACK FOOTER //
// src/views/BMS/alarmManagement/offlineAlarm/offlineAlarm.vue